export class UpdatePointAIRoadCommand {
    _road;
    _newPointPos;
    _oldPos;
    _pointID;
    _viewCallback;
    constructor(road, pointID, pointPosition, callback) {
        this._pointID = pointID;
        this._road = road;
        this._newPointPos = pointPosition;
        this._viewCallback = callback;
    }
    async execute() {
        this._oldPos = this._road.getControlPointPosition(this._pointID);
        this._road.updateControlPointPosition(this._pointID, this._newPointPos);
        this._road.update();
        this._viewCallback && this._viewCallback();
    }
    async undo() {
        this._road.updateControlPointPosition(this._pointID, this._oldPos);
        this._road.update();
        this._viewCallback && this._viewCallback();
    }
}
export class AddPointAIRoadCommand {
    _road;
    _pointPosition;
    _pointID;
    constructor(road, pointPosition) {
        this._road = road;
        this._pointPosition = pointPosition;
    }
    async execute(viewer) {
        const options = viewer.createIOptions(this._road.associatePointCloudId);
        this._pointID = this._road.addControlPoint(options.viewer, this._pointPosition);
    }
    async undo(viewer) {
        const options = viewer.createIOptions(this._road.associatePointCloudId);
        this._road.removeControlPoint(options.viewer, this._pointID);
    }
}
//# sourceMappingURL=ai-road-commands.js.map